/**
 * 获取可折叠面板组件配置信息、包含折叠切换按钮文案、折叠切换按钮icon type
 * @param isCollapsed 是否折叠
 * @returns 面板组件配置信息
 */
const getCollapseStateSwitchBtnConfig = (
  isCollapsed: boolean,
  collapsedText: string = 'Unfold',
  expandedText: string = 'Fold',
): {
  // 按钮文案
  btnText: string;
  // 按钮右侧的箭头icon type
  iconType: string;
} => {
  let btnText = '';
  let iconType = '';
  if (isCollapsed) {
    btnText = collapsedText;
    iconType = 'point-down';
  } else {
    btnText = expandedText;
    iconType = 'point-top';
  }
  return {
    btnText,
    iconType,
  };
};

export { getCollapseStateSwitchBtnConfig };
